import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {

  constructor(
    @Inject(forwardRef(() => MainComponent)) public app: MainComponent) { }
    
  @Input('step') step;

  ngOnInit(): void {
  }

}
